/* istanbul ignore file */
export enum ProductVariantType {
  COLOR = 'color',
  UNIT = 'unit',
}

export enum usStates {
  AL = 'Alabama',
  AK = 'Alaska',
  AZ = 'Arizona',
  AR = 'Arkansas',
  CA = 'California',
  CO = 'Colorado',
  CT = 'Connecticut',
  DE = 'Delaware',
  FL = 'Florida',
  GA = 'Georgia',
  HI = 'Hawaii',
  ID = 'Idaho',
  IL = 'Illinois',
  IN = 'Indiana',
  IA = 'Iowa',
  KS = 'Kansas',
  KY = 'Kentucky',
  LA = 'Louisiana',
  ME = 'Maine',
  MD = 'Maryland',
  MA = 'Massachusetts',
  MI = 'Michigan',
  MN = 'Minnesota',
  MS = 'Mississippi',
  MO = 'Missouri',
  MT = 'Montana',
  NE = 'Nebraska',
  NV = 'Nevada',
  NH = 'New Hampshire',
  NJ = 'New Jersey',
  NM = 'New Mexico',
  NY = 'New York',
  NC = 'North Carolina',
  ND = 'North Dakota',
  OH = 'Ohio',
  OK = 'Oklahoma',
  OR = 'Oregon',
  PA = 'Pennsylvania',
  RI = 'Rhode Island',
  SC = 'South Carolina',
  SD = 'South Dakota',
  TN = 'Tennessee',
  TX = 'Texas',
  UT = 'Utah',
  VT = 'Vermont',
  VA = 'Virginia',
  WA = 'Washington',
  WV = 'West Virginia',
  WI = 'Wisconsin',
  WY = 'Wyoming',
}

// Refer VISION catalog from commerce tools https://mc.us-central1.gcp.commercetools.com/kpdelta-dev/categories/list
export enum ProductCategoryKeys {
  EYEGLASS_FRAMES = 'eyeglass_frames',
  EYEGLASS_FRAMES_IN_STORE = 'eyeglass_frames.inStorePurchaseOnly',
  EYEGLASS_LENSES = 'eyeglass_lenses',
  CONTACT_LENSES = 'contact_lenses',
  CONTACT_LENSES_UNSECURE = 'contact_lenses.basePage',
  CONTACT_LENSES_SECURE = 'contact_lenses.securePage',
  SAVING_PLAN = 'savings_plans',
  LENS_TREATMENT = 'lens_treatment',
  LENS_TREATMENT_COATS = 'lens_treatment_coats',
  LENS_TREATMENT_TINTS = 'lens_treatment_tints',
  LENS_TREATMENT_EXTRAS = 'lens_treatment_extras',
  EYEGLASS_LENS_PROPS = 'eyeglass_lens_props',
}

export enum Gender {
  MEN = 'Men',
  WOMEN = 'Women',
  YOUTH = 'Youth',
}

export enum InternalLinks {
  home = '/',
  secureHome = '/secure/home',
  glasses = '/glasses',
  eyeglasses = '/glasses/eyeglasses',
  contactsPlp = '/contact-lenses',
  contacts = '/secure/order/contact-lenses',
  lensWizard = '/secure/glasses/lenses',
  bookEyeExam = '/secure/bookappointment',
  contactUs = '/contactus',
  checkout = '/secure/checkout',
  orderConfirmation = '/secure/order-confirmation',
  orders = '/secure/account/orders',
  account = '/secure/account',
  cart = '/secure/cart',
  address = '/secure/account/address',
  personal = '/secure/account/personal',
  savedForLater = '/secure/account/savedForLater',
  notFound = '/404',
  globalError = '/500',
  orderDetails = '/secure/account/orderDetails',
  cancelOrder = '/secure/account/cancelOrder',
  viewInvoice = '/secure/account/viewinvoice',
  eyeglassPdp = '/glasses/frames/pdp',
  secureFramesPDP = '/secure/framesPDP',
  guarantees = '/guarantees',
  contactsPdp = '/contact-lenses/pdp',
  findALocation = '/store/locations',
  mybenefits = '/secure/account/benefits',
  myPrescriptions = '/secure/account/rx',
  secureContactUs = '/secure/contactus',
  addFavorite = '/secure/addFavorite',
  contactsSigninPdp = '/secure/contactsSigninPdp',
}
export enum contactRedirectURL {
  redirectPDPtoPLP = '/contact-lenses',
  redirectPLPtoPDP = '/secure/order/contact-lenses',
}

export enum CardEventRules {
  NORULES = 'no_rule',
  SIGNEDOUTUSER = 'signed_out_user',
  SIGNEDUSER = 'singned_user',
}

export enum BenefitSelectionType {
  NONE = 'none',
  DONT_USE = 'dont-use',
}
